import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Typography, MenuItem, Select, Grid2, Modal, IconButton, Paper, Box, Switch, TextField, Alert, Snackbar } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Grid
} from '@mui/material';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TokenError from '../tokenError';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { styled } from '@mui/material/styles';
import editIcon from '../../assets/icons/edit.svg';
var constants = require('../../constant');

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const Fleets = () => {
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();

    const cities = JSON.parse(localStorage.getItem('cities'));
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [openAddFleet, setOpenAddFleet] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];

    const [fleetId, setFleetId] = useState('');
    const [fleetName, setFleetName] = useState('');
    const [city, setCity] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [email, setEmail] = useState('');
    const [vatNumber, setVatNumber] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [bankNumber, setBankNumber] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [vatEnabled, setVatEnabled] = useState(false);
    const operationsUrl = config.operationsUrl;
    const clientId = localStorage.getItem('clientId');
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    const paymentMethodConst = [
        { "payment_id": "1", "payment_name": "Razorpay" },
        { "payment_id": "2", "payment_name": "Stripe" },
    ]

    useEffect(() => {
        if (!openAddFleet){
            const loadDocuments = async () => {
                const data = await fetchFleetData();
                setRows(data); // Set rows with fetched data
            };
            loadDocuments();
        }
        
    }, [openAddFleet, cityFilter]);

    // useEffect(()=>{
    //     fetchFleetData();
    // },[cityFilter])

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'status') setStatusFilter(value);

        setIsFilterApplied(
            Boolean(value) || Boolean(statusFilter) || Boolean(cityFilter)
        );
    };

    const applyOrResetFilter = () => {
        if (isFilterApplied) {
            setStatusFilter('');
            setCityFilter('');
            setIsFilterApplied(false);
            const resetDocuments = async () => {
                const data = await fetchFleetData();
                setRows(data);
            };
            resetDocuments();
        } else {
            const filteredRows = rows.filter((document) =>
                (statusFilter ? document.status === statusFilter : true) &&
                (cityFilter ? document.city === cityFilter : true)
            );
            setRows(filteredRows);
        }
    };

    // Ensure rows is an array and calculate the number of pages safely
    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const currentPage = Math.min(page, totalPages - 1); // Avoid invalid page numbers

    const handleOpenAddFleet = () => {
        setEditMode(false); // Set to "Add" mode
        setSelectedDocument(null); // No pre-filled data
        setOpenAddFleet(true);
    };
    
    const handleCloseAddFleet = () => {
        setOpenAddFleet(false);
    };

    const fetchFleetData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/fleet/fetch_all`;
            const obj={
                token: token, timestamp: timestamp, city_id: cityFilter
            }

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            
            return response.data|| [];
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Function for document details
    const handleViewDetails = (row) => {
        setSelectedDocument({
            fleet_id: row.fleet_id,
            name: row.name,
            status: row.status,
            email: row.email,
            phone_no: row.phone_no,
            bank_details: {
                bank_name: row.bank_details.bank_name,
                vat_number: row.bank_details.vat_number,
                vat_enabled: row.bank_details.vat_enabled,
                payment_method: row.bank_details.payment_method,
            },
            city_id: cities.find(city => city.city_id === row.city_id)
        });
        setEditMode(true);
        // Delay setting `openAddDocument` to ensure React processes the previous updates
        setTimeout(() => {
            setOpenAddFleet(true);
        }, 0);
    };

    // Populate form fields in edit mode
    useEffect(() => {
        if (editMode && selectedDocument) {
            console.log('selectedDocument----', selectedDocument)
            // const payment = selectedDocument.bank_details.payment_method;
            const payment = paymentMethodConst.find(payment => payment.payment_id == selectedDocument.bank_details.payment_method);
            const paymentName = payment ? payment.payment_name : '--';

            setFleetId(selectedDocument.fleet_id || '');
            setFleetName(selectedDocument.name || '');
            setCity(selectedDocument.city_id.city_name || '');
            setMobileNumber(selectedDocument.phone_no || '');
            setEmail(selectedDocument.email || '');
            setPaymentMethod(paymentName || 'Razorpay');
            setIsActive(selectedDocument.status === 1);
            setBankNumber(selectedDocument.bank_details.bank_name || '');
            setVatNumber(selectedDocument.bank_details.vat_number || '');
            setVatEnabled(selectedDocument.bank_details.vat_enabled === 1);
        } else {
            // Reset fields in add mode
            resetFormFields();
        }
    }, [editMode, selectedDocument]);

    // Function to reset form fields
    const resetFormFields = () => {
        setFleetId('');
        setFleetName('');
        setCity('');
        setMobileNumber('');
        setVatNumber('');
        setEmail('');
        setBankNumber('');
        setIsActive(true);
        setPaymentMethod('Razorpay');
        // setGalleryRestricted(false);
        setVatEnabled(false);
    };
    
    // Function to handle saving the document
    const handleSubmit = async () => {

        const payload = {
            name: fleetName,
            city_id: clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || null,
            client_id: parseInt(clientId),
            status: isActive ? 1 : 0,
            phone_no: mobileNumber,
            email: email,
            bank_details :{
                bank_name: bankNumber,
                vat_number: vatNumber,
                vat_enabled: vatEnabled ? vatEnabled : 0,
                payment_method: paymentMethodConst.find((paymentObj) => paymentObj.payment_name === paymentMethod)?.payment_id || null
            }
        };

        // Include `document_id` in the payload if in edit mode
        if (editMode && fleetId) {
            payload.fleet_id = fleetId;
        }

        try {
            const url = operationsUrl + '/fleet/add_update_fleet';
            var response = await axios.post(url, payload);

            if(response.data.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }

            if (response.data.flag === 200) {
                console.log('Document saved successfully:', response.data.message);
                setMessage(response.data.message)
                showSnackbar(true);

            } else {
                console.error('Failed to save document:', response.data.message);
                setMessage(response.data.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

        handleCloseAddFleet(); // Close the modal after saving
        fetchFleetData();
    };

    // Reset the form fields
    const handleReset = () => {
        resetFormFields();
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };
    return (
        <div>
            {tokenExpired && (<TokenError/>)}

                    <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                        Fleets
                    </Typography>

                    <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '2%' }}>
                        {/* Filter controls */}
                        <Grid2 item>
                            <Select
                                value={cityFilter}
                                onChange={(e) => handleFilterChange('city', e.target.value)}
                                displayEmpty
                                style={{
                                    width: '220px',
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                                }}
                            >
                                <MenuItem value="">Select City</MenuItem>
                                {cities.map((city) => (
                                    <MenuItem key={city.city_id} value={city.city_id}>
                                        {city.city_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid2>
                        <Grid2 item>
                            <Select
                                value={statusFilter}
                                onChange={(e) => handleFilterChange('status', e.target.value)}
                                displayEmpty
                                style={{
                                    width: '220px',
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF',
                                }}
                            >
                                <MenuItem value="">Status</MenuItem>
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Inactive">Inactive</MenuItem>
                            </Select>
                        </Grid2>
                        <Grid2 item style={{ marginLeft: '4%' }}>
                            <Button
                                variant="contained"
                                onClick={applyOrResetFilter}
                                style={{
                                    width: '185px',
                                    height: '50px',
                                    marginRight: '1px',
                                    backgroundColor: isFilterApplied ? '#F5BB19' : '#0065FF',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                {isFilterApplied ? 'Reset Filter' : 'Apply Filter'}
                            </Button>
                        </Grid2>
                        <Grid2 item>
                            <Button
                                variant="contained"
                                onClick={handleOpenAddFleet}
                                style={{
                                    width: '185px',
                                    height: '50px',
                                    backgroundColor: '#000000',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                + Add Fleet
                            </Button>
                        </Grid2>
                    </Grid2>

                    {/* Sidebar for AddDocument */}
                    <div
                        style={{
                            position: 'fixed',
                            top: 65,
                            right: openAddFleet ? 0 : '-100%',
                            height: '100%',
                            width: '50%',
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                            transition: 'right 0.3s ease-in-out',
                            zIndex: 1000,
                            overflowY: 'auto',
                            padding: 20
                        }}
                    >
                        <Box onClose={handleCloseAddFleet} editMode={editMode}>
                            <div style={{ position: 'relative', padding: '40px 0' }}>
                                {/* Close Button Outside the Card */}
                                <IconButton
                                    aria-label="close"
                                    onClick={handleCloseAddFleet}
                                    style={{
                                        position: 'absolute',
                                        top: '-15px', // Position it above the Paper component
                                        left: '1px',
                                        color: '#333',
                                        zIndex: 10,
                                    }}
                                >
                                    <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                                </IconButton>
                                <Paper elevation={3}
                                    style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                        backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                    <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                        {editMode ? 'Edit Fleet' : 'Add Fleet'}
                                    </Typography>

                                    {editMode && (
                                        <div style={{display: 'flex', alignItems: 'center', backgroundColor: '#fff', padding: '10px 20px',
                                            border: '1px solid #E0E0E0', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                            marginBottom: '20px', marginTop: '50px'}}>
                                            <Typography variant="body1" style={{ color: '#4A4A4A' }}>
                                                Fleet
                                            </Typography>
                                            <div style={{ display: 'flex', marginLeft: 'auto' }}>
                                                <Button variant="contained"
                                                    onClick={() => setIsActive(true)} // Fixed: Use setIsActive
                                                    style={{backgroundColor: isActive ? '#0DBA78' : '#F4F4F4',
                                                        color: isActive ? '#FFFFFF' : '#9E9E9E',
                                                        textTransform: 'none', borderRadius: '8px 0 0 8px',
                                                        boxShadow: 'none', padding: '6px 16px', minWidth: '80px'}}>
                                                    Enable
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    onClick={() => setIsActive(false)} // Fixed: Use setIsActive
                                                    style={{
                                                        backgroundColor: !isActive ? '#D14545' : '#F4F4F4', // Fixed: Use isActive
                                                        color: !isActive ? '#FFFFFF' : '#9E9E9E', textTransform: 'none',
                                                        borderRadius: '0 8px 8px 0', // Rounded on the right side
                                                        boxShadow: 'none', padding: '6px 16px', minWidth: '80px'}}>
                                                    Disable
                                                </Button>
                                            </div>
                                        </div>
                                    )}

                                    <Grid container spacing={2}>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span>Fleet Name <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="Enter Fleet Name"
                                                fullWidth
                                                variant="outlined"
                                                value={fleetName}
                                                onChange={(e) => setFleetName(e.target.value)}
                                                InputProps={{
                                                    style: {
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#E0E0E0',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '16px',
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span>City <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="Select City"
                                                select
                                                fullWidth
                                                variant="outlined"
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                                InputProps={{
                                                    style: {height: '56px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#E0E0E0',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '16px',
                                                    },
                                                }}
                                            >
                                            {clientCities.map((cityObj) => (
                                                <MenuItem key={cityObj.city_id} value={cityObj.city_name}>
                                                    {cityObj.city_name}
                                                </MenuItem>
                                            ))}
                                            </TextField>
                                        </Grid>
                                        
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span> Mobile Number <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="Mobile Number"
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                value={mobileNumber}
                                                onChange={(e) => setMobileNumber(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#E0E0E0',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '16px',
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span> Email <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="Email"
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#E0E0E0',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '16px',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span> VAT Number <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="VAT Number"
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                value={vatNumber}
                                                onChange={(e) => setVatNumber(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#E0E0E0',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '16px',
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span> Bank Name <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="Bank Name"
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                value={bankNumber}
                                                onChange={(e) => setBankNumber(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#E0E0E0',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '16px',
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span> Payment Gateway <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="Payment Gateway"
                                                select
                                                fullWidth
                                                variant="outlined"
                                                value={paymentMethod}
                                                onChange={(e) => setPaymentMethod(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: { height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E0E0'},
                                                    '& .MuiInputLabel-root': {fontSize: '16px'}
                                                }}
                                            >
                                            {paymentMethodConst.map((paymentObj) => (
                                                <MenuItem key={paymentObj.payment_id} value={paymentObj.payment_name}>
                                                    {paymentObj.payment_name}
                                                </MenuItem>
                                            ))}
                                            </TextField>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: '10px 20px',
                                                    border: '1px solid #D1D5DB',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#FFFFFF',
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        paddingLeft: '1px',
                                                        color: '#4A4A4A',
                                                    }}
                                                >
                                                    VAT Enabled <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography
                                                        variant="body1"
                                                        style={{
                                                            marginRight: '8px',
                                                            color: vatEnabled ? '#4A4A4A' : '#9E9E9E',
                                                        }}
                                                    >
                                                        {vatEnabled ? 'Yes' : 'No'}
                                                    </Typography>
                                                    <IOSSwitch
                                                        checked={vatEnabled}
                                                        onChange={(e) => setVatEnabled(e.target.checked)}
                                                    />
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>

                                    <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                            sx={{
                                                width: '140px',
                                                height: '50px',
                                                textTransform: 'none',
                                                fontSize: '16px',
                                                backgroundColor: '#0065FF',
                                                color: 'white',
                                            }}
                                        >
                                            {editMode ? 'Update' : 'Save'}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={handleReset}
                                            sx={{
                                                width: '140px',
                                                height: '50px',
                                                textTransform: 'none',
                                                fontSize: '16px',
                                                backgroundColor: '#F0F0F0',
                                                color: '#B0B0B0',
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                </Paper>

                            </div>
                        </Box>
                    </div>

                    {/* Documents Table */}
                    <TableContainer className="table-container">
                        <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                        <TableSortLabel
                                            active={orderBy === 'fleet_id'}
                                            direction={orderBy === 'fleet_id' ? order : 'asc'}
                                            onClick={() => handleRequestSort('fleet_id')}
                                        >
                                            ID
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fleet Name</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Phone Number</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Email</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '10%' }}>City</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '10%' }}>Bank Name</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '10%' }}>VAT Number</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '10%' }}>VAT Enabled</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '10%' }}>Payment Gateway</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '10%' }}>Status</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows
                                    .filter((row) => {
                                        const isStatusMatch = statusFilter 
                                            ? (statusFilter === 'Active' ? row.status === 1 : row.status === 0) 
                                            : true;
                                        const isCityMatch = cityFilter ? row.city_id === cityFilter : true;

                                        return isStatusMatch && isCityMatch;
                                    })
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => {
                                        const city = clientCities.find(city => city.city_id === row.city_id);
                                        const cityName = city ? city.city_name : '---';

                                        const payment = paymentMethodConst.find(payment => payment.payment_id == row.bank_details.payment_method);
                                        const paymentName = payment ? payment.payment_name : '--';
                                        return(
                                            <TableRow key={row.fleet_id}>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fleet_id}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.name}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.phone_no}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.email}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{cityName}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.bank_details.bank_name}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.bank_details.vat_number}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.bank_details.vat_enabled==1 ? 'Yes': 'No'}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{paymentName}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.status === 1 ? '#0DBA78' : '#D14545', fontWeight:'500' }}>{row.status==1 ? 'Active' : 'Inactive'}</Typography></TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    variant="contained"
                                                    onClick={() => handleViewDetails(row)}
                                                    sx={{
                                                        backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                        borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                        '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                        '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                                    }}>
                                                    
                                                    <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                        <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                                    </svg>
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                        
                        <div className="custom-pagination">
                            <div className="pagination-info">
                                {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                    (page + 1) * rowsPerPage,
                                    rows.length
                                )} of ${rows.length} entries`}
                            </div>
                            <div className="pagination-controls">
                            <button
                                onClick={() => handleChangePage(null, page - 1)}
                                disabled={page === 0}
                                className="pagination-arrow"
                            >
                                <img src={prevIcon} alt="Previous" />
                            </button>
                                <div className="pagination-numbers">
                                    {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                        <button key={index} onClick={() => handleChangePage(null, index)}
                                            className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                            {index + 1}
                                        </button>
                                    ))}
                                </div>
                                <button
                                    onClick={() => handleChangePage(null, page + 1)}
                                    disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                    className="pagination-arrow"
                                >
                                    <img src={nextIcon} alt="Next" />
                                </button>
                            </div>
                        </div>
                    </TableContainer>

                    {/* <Alert severity="error" sx={{width:'40%', marginLeft:'auto'}}>{message}</Alert> */}
                    <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                
        </div>
    );
    
};

export default Fleets